import { useCallback, useState } from 'react';

/**
 * State-based increment for the purchase attempt.
 */
export const usePurchaseAttempt = () => {
  const [purchaseAttempt, setPurchaseAttempt] = useState(0);

  const incrementPurchaseAttempt = useCallback(() => {
    setPurchaseAttempt((prev) => prev + 1);
  }, []);

  return { purchaseAttempt, incrementPurchaseAttempt };
};
